export function serializeQueryKey(key: unknown): string {
  try {
    return JSON.stringify(key);
  } catch {
    return String(key);
  }
}

export function buildScrollKey(prefix: string, queryKey: unknown): string {
  return `${prefix}:${serializeQueryKey(queryKey)}`;
}
